module.exports = __webpack_public_path__ + "static/media/grandhyatt-1.e1a08e79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/partner-hotels/grand-hyatt/grandhyatt-1.jpg
// module id = 712
// module chunks = 6